import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { menusRoles } from '../../constantes/menu/menu-left-by-role.constantes';
import { menuTop } from '../../constantes/menu/menu-top.constantes';
import { ContextDroitsModel } from '../../models/menu/context-droits.model';
import { MenuItemModel } from '../../models/menu/menu-item.model';
import { InformationsProfilModel } from '../../models/profils/informations-profil.model';
import { ConfigService } from '../config/config.service';
import { CookiesService } from '../cookies.service';
import { UtilisateurCourantService } from '../utilisateurs/utilisateur-courant.service';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  public version;
  public newVersion: boolean = false;

  constructor(
    private injector: Injector,
    private userService: UtilisateurCourantService,
    private configService: ConfigService,
    private cookieService: CookiesService) {
  }

  getMenuLeft(): Observable<Array<MenuItemModel>> {
    return this.userService
      .getInformationsProfilUtilisateur()
      .pipe(switchMap(informations => this.buildMenuLeftFromInformationsProfil(informations)));
  }

  getMenuTop(): Observable<Array<MenuItemModel>> {
    return this.userService.getInformationsProfilUtilisateur().pipe(
      switchMap(informations =>
        menuTop.buildMenuFromContext({
          droits: informations.droits,
          injectorContext: this.injector,
        }),
      ),
    );
  }

  private buildMenuLeftFromInformationsProfil(
    informationsProfil: InformationsProfilModel,
  ): Observable<Array<MenuItemModel>> {
    const menuRole = menusRoles.find(o => o.role === informationsProfil.codeRole);
    const context: ContextDroitsModel = {
      droits: informationsProfil.droits,
      injectorContext: this.injector,
    };

    return menuRole.menuItems.buildMenuFromContext(context);
  }
}
